import * as React from 'react'

export interface ICharacterCounter {
  numOfChar: number
}

class CharacterCounter extends React.Component<any, any> {
  constructor(props: ICharacterCounter) {
    super(props)
  }

  public render() {
    return (
      <div className='flex justify-end'>
        <p className={this.getClass(this.props.numOfChar)}>{this.props.numOfChar} characters remaining</p>
      </div>
    )
  }

  private getClass = (numOfChar: number) => {
    if (numOfChar === 0) {
      return 'mt1 mb0 h5 font-red'
    } else if (numOfChar <= 15) {
      return 'mt1 mb0 h5 font-orange'
    } else {
      return 'mt1 mb0 h5'
    }
  }
}

export default CharacterCounter



// WEBPACK FOOTER //
// ./src/components/ui/CharacterCounter.tsx